import {
	CheckboxInput,
	Label,
	Select,
	TextInput,
	TimeInput,
} from 'components/Form'
import { Loading } from 'components/index'
import Table from 'components/Table/index'
import notification from 'helpers/notification'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import services from 'services/index'

const UpdateForm = () => {
	const role = useSelector(store => store?.user?.user?.user_type)
	const navigate = useNavigate()
	const params = useParams()
	const { id } = params
	const [disabled, setDisabled] = useState(false)
	const [updateData, setUpdateData] = useState()
	const [teachers, setTeachers] = useState([])
	const [students, setStudents] = useState([])
	const [search, setSearch] = useState('')
	const [loading, setLoading] = useState(true)

	const handleSelectAll = () => {
		const selectedAll = students.map(item => item.id)
		if (updateData?.students?.length === students?.length) {
			setUpdateData({ ...updateData, students: [] })
		} else {
			setUpdateData({ ...updateData, students: selectedAll })
		}
	}
	const handleSelect = data => {
		if (updateData?.students?.some(item => item.id === data?.id)) {
			setUpdateData({
				...updateData,
				students: updateData?.students?.filter(item => item?.id !== data?.id),
			})
		} else {
			const newStudentsList = [...updateData?.students, data]
			setUpdateData({ ...updateData, students: newStudentsList })
		}
	}
	const headers = [
		{
			key: 'checkbox',
			label: (
				<CheckboxInput
					type='checkbox'
					value={updateData?.students?.length === students?.length}
					onChange={handleSelectAll}
					className='w-4 h-4'
				/>
			),
			width: '50px',
			getContent: ({ data }) => (
				<CheckboxInput
					type='checkbox'
					value={updateData?.students?.some(item => item?.id === data.id)}
					onChange={() => handleSelect(data)}
					className='w-4 h-4'
				/>
			),
		},
		{
			key: 'first_name',
			label: 'Ism',
			getContent: ({ data, key, index }) => {
				const name = data?.first_name
				return <div className='text-start'>{name}</div>
			},
		},
		{
			key: 'last_name',
			label: 'Familiya',
			getContent: ({ data, key, index }) => {
				const name = data?.last_name
				return <div className='text-start'>{name}</div>
			},
		},
		{
			key: 'student_class',
			label: 'Sinf',
			getContent: ({ data, key, index }) => {
				const date = data?.student_class
				return <div className='text-start'>{date}</div>
			},
		},
		{
			key: 'phone_number',
			label: 'Otaining telefon raqami',
			getContent: ({ data, key, index }) => {
				const phone = data?.phone_number || '-'
				return <div className='text-start'>{phone}</div>
			},
		},
		{
			key: 'phone_number',
			label: 'Onasining telefon raqami',
			getContent: ({ data, key, index }) => {
				const phone = data?.phone_number2 || '-'
				return <div className='text-start'>{phone}</div>
			},
		},
	]
	const weekDay = id => {
		const isSelectDay = updateData?.weekdays?.includes(id)
		isSelectDay
			? setUpdateData({
					...updateData,
					weekdays: updateData?.weekdays?.filter(item => item !== id),
			  })
			: setUpdateData({
					...updateData,
					weekdays: [...updateData?.weekdays, id],
			  })
	}
	const getGroupsById = id => {
		const options = {
			id,
			role,
			onError: () => setUpdateData({}),
			onSuccess: response => {
				const results = response?.data
				setUpdateData({
					...results,
					teachers: {
						value: results?.teachers?.id,
						label:
							results?.teachers?.first_name +
							' ' +
							results?.teachers?.last_name,
					},
				})
				setTimeout(() => {
					setLoading(false)
				}, 1000)
			},
		}
		services.groups.getGroupById(options)
	}
	const getTeachers = () => {
		const options = {
			filter: { page: 1, page_size: 1000 },
			onError: () => setTeachers([]),
			onSuccess: response => {
				const newData = []
				const results = response?.data?.results
				results?.map(item =>
					newData?.push({
						label: item?.first_name + ' ' + item?.last_name,
						value: item?.id,
					})
				)
				setTeachers(newData)
			},
		}
		services.teachers.getTeachers(options)
	}
	const getStudents = () => {
		const options = {
			filter: { page: 1, page_size: 10000, search },
			onError: () => setStudents([]),
			onSuccess: response => {
				const results = response?.data?.results
				setStudents(results)
			},
		}
		services.students.getStudents(options)
	}
	useEffect(() => {
		getTeachers()
		id && getGroupsById(id)
	}, [id])

	useEffect(() => {
		getStudents()
	}, [search, id])

	const updateGroup = () => {
		const options = {
			data: {
				...updateData,
				students: updateData?.students?.map(item => item?.id),
				teachers: updateData?.teachers?.value,
			},
			onStart: () => setDisabled(true),
			onError: error => notification('Error', { type: 'error' }),
			onEnd: () => setDisabled(false),
			onSuccess: response => {
				if (response?.status === 200) {
					setUpdateData({})
					navigate(-1)
					notification("Guruh ma'lumotlari muvaffaqiyatli yangilandi!", {
						type: 'success',
					})
				} else {
					notification('Error', { type: 'error' })
				}
			},
		}
		services.groups.updateGroups(options)
	}
	return loading ? (
		<div className='h-[70vh]'>
			<Loading />
		</div>
	) : (
		<div className='pt-6'>
			<div className='grid grid-cols-12 gap-4 mb-6'>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Guruh nomi</Label>
					<TextInput
						size='small'
						value={updateData?.name}
						onChange={name => setUpdateData({ ...updateData, name })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>O’qituvchi</Label>
					<Select
						isClearable={false}
						size='small'
						options={teachers}
						value={updateData?.teachers}
						onChange={value =>
							setUpdateData({ ...updateData, teachers: value })
						}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>To’lov summasi</Label>
					<TextInput
						size='small'
						value={updateData?.price}
						onChange={price => setUpdateData({ ...updateData, price })}
					/>
				</div>
				<div className='col-span-12 sm:col-span-4'>
					<Label>Dars vaqti</Label>
					<div className='grid grid-cols-2 gap-4'>
						<TimeInput
							size='small'
							placeholder='Boshlanish vaqti'
							value={updateData?.start_time}
							onChange={start_time =>
								setUpdateData({ ...updateData, start_time })
							}
						/>
						<TimeInput
							size='small'
							placeholder='Tugash vaqti'
							value={updateData?.end_time}
							onChange={end_time => setUpdateData({ ...updateData, end_time })}
						/>
					</div>
				</div>
				<div className='col-span-12'>
					<Label>Hafta kunlari</Label>
					<div className='flex flex-wrap flex-col sm:flex-row gap-6'>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={updateData?.weekdays?.includes('0')}
								onChange={() => weekDay('0')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Dushanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={updateData?.weekdays?.includes('1')}
								onChange={() => weekDay('1')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Seshanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={updateData?.weekdays?.includes('2')}
								onChange={() => weekDay('2')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Chorshanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={updateData?.weekdays?.includes('3')}
								onChange={() => weekDay('3')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Payshanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={updateData?.weekdays?.includes('4')}
								onChange={() => weekDay('4')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Juma
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={updateData?.weekdays?.includes('5')}
								onChange={() => weekDay('5')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Shanba
							</span>
						</div>
						<div className='flex items-center gap-2'>
							<CheckboxInput
								size='small'
								value={updateData?.weekdays?.includes('6')}
								onChange={() => weekDay('6')}
							/>
							<span className='text-[14px] text-[#292A32] dark:text-[#ffffff] leading-none'>
								Yakshanba
							</span>
						</div>
					</div>
				</div>
			</div>
			<div className='flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-3'>
				<h3 className='text-[18px] lg:text-[22px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
					O'quvchilarni tanlang
				</h3>
				<div className='max-w-full sm:max-w-[300px]'>
					<TextInput
						size='small'
						placeholder='Izlash...'
						value={search}
						onChange={value => setSearch(value)}
					/>
				</div>
			</div>
			<Table
				data={students}
				headers={headers}
				isLoading={loading}
				emptyMessage="Ma'lumot topilmadi"
				withPadding={true}
			/>
			<div className='flex justify-center sm:justify-end mt-4'>
				<button
					disabled={disabled}
					className='success-btn w-full sm:w-auto'
					onClick={updateGroup}
				>
					Saqlash
				</button>
			</div>
		</div>
	)
}

export default UpdateForm
